import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

import Dashboard from '@/views/Dashboard.vue'
import AboutCardView from '@/views/AboutCard.vue'
import MyCardsView from '@/views/MyCards.vue'
import CardDetailView from '@/views/CardDetail.vue'
import CardBindView from '@/views/CardBind.vue'
import NotFoundView from '@/views/NotFound.vue'
import RulesView from '@/views/Rules.vue'
import SetCountry from '@/views/SetCountry/SetCountry'
import RandomRewards from '@/views/RandomRewards'
import OffersView from '@/views/OffersView'
import { AVAILABLE_COUNTRIES } from '@/constants'

Vue.use(Router)

export const AVAILABLE_LAYOUTS = {
  DEFAULT: 'DEFAULT',
  LANDING: 'LANDING',
  WITHOUT_FORCE_LOGIN: 'WITHOUT_FORCE_LOGIN'
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'active',
  linkExactActiveClass: 'active',
  scrollBehavior: (to, from, savedPosition) => (savedPosition || { x: 0, y: 0 }),
  routes: [
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard
    },
    {
      path: '/cards',
      name: 'cards',
      component: MyCardsView,
      children: [
        {
          path: ':cardCode',
          name: 'card_detail',
          component: CardDetailView,
          props: true
        }
      ]
    },
    {
      path: '/about/:slug?/:partner?',
      name: 'about',
      component: AboutCardView,
      props: true
    },
    {
      path: '/bind',
      name: 'bind',
      component: CardBindView
    },
    {
      path: '/offers/:game?',
      name: 'offers',
      component: OffersView,
      meta: {
        layout: AVAILABLE_LAYOUTS.WITHOUT_FORCE_LOGIN
      },
      props: true
    },
    {
      path: '/rules/:partner?',
      name: 'rules',
      component: RulesView,
      meta: {
        layout: AVAILABLE_LAYOUTS.WITHOUT_FORCE_LOGIN
      },
      props: true
    },
    {
      path: '/landing/choose-partner-for-card-recharge',
      name: 'set-country',
      component: SetCountry,
      meta: {
        layout: AVAILABLE_LAYOUTS.LANDING
      },
      props: true
    },
    {
      path: '/tblitz-quest',
      name: 'random-rewards',
      component: RandomRewards,
      meta: {
        layout: AVAILABLE_LAYOUTS.WITHOUT_FORCE_LOGIN
      },
      props: true
    },
    {
      path: '*',
      name: 'not-found',
      component: NotFoundView
    }
  ]
})
router.beforeEach(async (to, from, next) => {
  // for set country when redirect from landing page
  if (to.query.country) {
    to.query.country = to.query.country.toUpperCase()
    if (AVAILABLE_COUNTRIES[to.query.country.toUpperCase()]) {
      store.dispatch('changeCountry', to.query.country)
      // const query = {
      //   ...to.query
      // }
      delete to.query.country
      router.replace(to)
    }
  }

  if (to.meta.layout) {
    return next()
  }

  if (!store.state.auth.requested && !store.state.auth.isAuthorizing) {
    await store.dispatch('auth/authenticate')
  }
  next()
})

export default router
